import {
    Autocomplete,
    Button,
    Grid,
    TextField,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const MainFoodItemTab = ({ mainFoodItem, setMainFoodItem, mainRankOptions }) => {
    const updateMainFoodItem = async (foodItem) => {
        try {
            const response = await axios.patch(`${process.env.REACT_APP_SECRET}/api/FoodItems/UpdateRankByFoodItemId?id=${foodItem.id}&rank=${foodItem.rank}`);
            console.log(response.data);
            toast.success("Rank Updated");
        } catch (error) {
            console.log(error);
            toast.error("Unable to update rank")
        }
    };

    console.log(mainFoodItem)
    console.log(mainRankOptions)
    return (
        <div>
            <ToastContainer />
            <Grid container sx={{ padding: "0.5rem", display: "flex", alignItems: "center" }} spacing={2}>
                <Grid item xs={2}>
                    <div
                        className="d-flex"
                        style={{ paddingTop: "1rem", gap: "10px" }}
                    >
                        <Typography>Main Food</Typography>
                    </div>
                </Grid>

                <Grid item xs={7}>
                    <Autocomplete
                        id='restaurant-dropdown'
                        options={[]} // No dropdown options
                        freeSolo
                        value={mainFoodItem}
                        onChange={(event, newValue) => setMainFoodItem(newValue)}
                        className='my-3'
                        getOptionLabel={(option) => option.itemName || ''}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant='outlined'
                                placeholder="Main Food"
                                label='Main Food'
                            />
                        )}
                    />
                </Grid>

                <Grid item xs={3}>
                    <Autocomplete
                        id='rank'
                        options={mainRankOptions}
                        // options={[1, 2, 3, 4, 5]}
                        value={mainRankOptions.includes(mainFoodItem?.rank) 
                            ? mainFoodItem.rank 
                            : null}
                        //value={"test"}
                        onChange={(event, newValue) => {
                            setMainFoodItem(prevState => ({
                                ...prevState,
                                rank: newValue
                            }));
                        }}
                        className='my-3'
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant='outlined'
                                placeholder="Rank"
                                label='Rank'
                            />
                        )}
                    />
                </Grid>
            </Grid>

            <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={12}>
                    <div className="d-flex justify-content-end">
                        <Button
                        onClick={() => {
                            updateMainFoodItem(mainFoodItem);
                        }}
                        >
                            Save
                        </Button>
                    </div>
                </Grid>
            </Grid>
        </div>
    );
};

export default MainFoodItemTab;